import { render, staticRenderFns } from "./Carpati.vue?vue&type=template&id=7b0897f0&"
import script from "./Carpati.vue?vue&type=script&lang=js&"
export * from "./Carpati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports